import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "node_modules/@mui/material/esm/Checkbox/Checkbox";
import { Controller, useFormContext } from "react-hook-form";

export default function ControlledCheckbox({
  name,
  label,
}: {
  name: string;
  label: string;
}) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          label={label}
          control={<Checkbox checked={field.value} {...field} />}
        />
      )}
    />
  );
}
